/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Hard_TiInputs */

const en_funnel_ob_ben_hard_ti = /** @type {(inputs: Funnel_Ob_Ben_Hard_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never lose your place again.`)
};

const es_funnel_ob_ben_hard_ti = /** @type {(inputs: Funnel_Ob_Ben_Hard_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vuelvas a perder el hilo.`)
};

/**
* | output |
* | --- |
* | "Never lose your place again." |
*
* @param {Funnel_Ob_Ben_Hard_TiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_hard_ti = /** @type {((inputs?: Funnel_Ob_Ben_Hard_TiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Hard_TiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_hard_ti(inputs)
	return en_funnel_ob_ben_hard_ti(inputs)
});